import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export default () => {
  return (
    <Tooltip
      overlayInnerStyle={{ width: '400px' }}
      title={
        <ul>
          <li>0星 待跟进 没有有效沟通或者没有探出任何客户的资质</li>
          <li>1星 资质不符 完全没有可贷条件、自由职业者无资产之类</li>
          <li>1星 捣乱申请 空号、停机、老赖、黑户、执行人、逾期时间很长；态度不好、骂人、要举报、投诉之类；异地且不来上海的</li>
          <li>2星 待签约 只有社保/一辆价值不高的车/有公积金或营业执照但征信不好（满足其一）</li>
          <li>3星 待签约 本地人/名下有上海房/有公积金/有营业执照（满足其一）</li>
          <li>4星 待签约 优质公积金（1000以上）/优质上海房（市值200万以上）/优质营业执照（有开票纳税）（满足其一）</li>
          <li>5星 待签约 优质公积金、优质上海房、优质营业执照同时拥有两者及以上</li>
        </ul>
      }
    >
      <InfoCircleOutlined />
    </Tooltip>
  );
};
